class AlertService {
    static alertModal = null;

    
}
export default AlertService;
